import API from "../../utils/endpoints";
import history from "../../history";
import * as types from "./actionType";
import { toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

const errorMessage = {
  status: 400,
  message: "Something went wrong",
};

function fetchingPartnersList() {
  return {
    type: types.FETCH_PARTNERS_LIST,
  };
}

function fetchingPartnersListSuccess(payload, count, pendingCount) {
  return {
    type: types.FETCH_PARTNERS_LIST_SUCCESS,
    payload,
    count,
    pendingCount,
  };
}

function fetchingPartnersListFailed() {
  return {
    type: types.FETCH_PARTNERS_LIST_FAILED,
  };
}

function fetchingPartnersDetails() {
  return {
    type: types.FETCH_PARTNERS_DETAILS,
  };
}

function fetchingPartnersDetailsSuccess(payload, count) {
  return {
    type: types.FETCH_PARTNERS_DETAILS_SUCCESS,
    payload,
    count,
  };
}

function fetchingPartnersDetailsFailed() {
  return {
    type: types.FETCH_PARTNERS_DETAILS_FAILED,
  };
}

function fetchingPartnersUpdatedDetails() {
  return {
    type: types.PARTNER_UPDATE_DETAILS,
  };
}

function fetchingPartnersUpdatedDetailsSuccess(payload, count) {
  return {
    type: types.PARTNER_UPDATE_DETAILS_SUCCESS,
    payload,
    count,
  };
}

function fetchingPartnersUpdatedDetailsFailed() {
  return {
    type: types.PARTNER_UPDATE_DETAILS_FAILED,
  };
}

function fetchingState() {
  return {
    type: types.FETCH_STATE,
  };
}

function fetchingStateSuccess(payload) {
  return {
    type: types.FETCH_STATE_SUCCESS,
    payload,
  };
}

function fetchingStateFailed() {
  return {
    type: types.FETCH_STATE_FAILED,
  };
}

function fetchingCity() {
  return {
    type: types.FETCH_CITY,
  };
}

function fetchingCitySuccess(payload) {
  return {
    type: types.FETCH_CITY_SUCCESS,
    payload,
  };
}

function fetchingCityFailed() {
  return {
    type: types.FETCH_CITY_FAILED,
  };
}

function createPartner() {
  return {
    type: types.FETCH_PARTNERS_DETAILS_POST,
  };
}

function createPartnerSuccess(payload) {
  return {
    type: types.FETCH_PARTNERS_DETAILS_POST_SUCCESS,
    payload,
  };
}

function createPartnerFailed() {
  return {
    type: types.FETCH_PARTNERS_DETAILS_POST_FAILED,
  };
}

function DeletePartner() {
  return {
    type: types.FETCH_PARTNERS_DETAILS_POST,
  };
}

function DeletePartnerSuccess(payload) {
  return {
    type: types.FETCH_PARTNERS_DETAILS_POST_SUCCESS,
    payload,
  };
}

function DeletePartnerFailed() {
  return {
    type: types.FETCH_PARTNERS_DETAILS_POST_FAILED,
  };
}

function pieChartStatistics() {
  return {
    type: types.PIE_CHART_STATISTICS,
  };
}

function pieChartStatisticsSuccess(payload) {
  return {
    type: types.PIE_CHART_STATISTICS_SUCCESS,
    payload,
  };
}

function pieChartStatisticsFailed(payload) {
  return {
    type: types.PIE_CHART_STATISTICS_FAILED,
    payload,
  };
}

function partnerRanking() {
  return {
    type: types.PARTNER_RANKING,
  };
}

function partnerRankingSuccess(payload) {
  return {
    type: types.PARTNER_RANKING_SUCCESS,
    payload,
  };
}

function partnerRankingFailed(payload) {
  return {
    type: types.PARTNER_RANKING_FAILED,
    payload,
  };
}

export function clearingPreviousReducer() {
  return {
    type: types.CLEAR_PREVIOUS_REDUCERS,
  };
}

export const fetchPartnersList = (payload, data) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingPartnersList());
  try {
    let response = data
      ? await api.get(
          `${API.fetchPartnersList}?page=${payload.page}&limit=${payload.limit}`
          // `${API.fetchPartnersList}?page=${payload.page}&limit=${payload.limit}&status=${payload.status}&country=${payload.country}&state=${payload.state}&city=${payload.city}&email=${payload.email}&phone=${payload.phone}`
        )
      : await api.get(
          `${API.fetchPartnersList}?page=${payload.page}&limit=${payload.limit}&status=${payload.status}&country=${payload.country}&email=${payload.email}&phone=${payload.phone}`
          // `${API.fetchPartnersList}?page=${payload.page}&limit=${payload.limit}&status=${payload.status}&country=${payload.country}&state=${payload.state}&city=${payload.city}&email=${payload.email}&phone=${payload.phone}`
        );

    if (response.data.code === 200) {
      dispatch(
        fetchingPartnersListSuccess(
          response.data.data.foundPartner,
          response.data.data.count,
          response.data.data.pendingCount
        )
      );
    } else {
      dispatch(fetchingPartnersListFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchingPartnersListFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const fetchUpdatedPartnersData = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingPartnersUpdatedDetails());
  try {
    let response = await api.get(`${API.updatePartner}?partnerId=${payload}`);
    if (response.data.code === 200) {
      dispatch(fetchingPartnersUpdatedDetailsSuccess(response.data.data));
    } else {
      dispatch(fetchingPartnersUpdatedDetailsFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchingPartnersUpdatedDetailsFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const fetchPartnersDetails = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingPartnersDetails());
  try {
    let response = await api.get(
      `${API.fetchPartnersDeatils}?partnerId=${payload}`
    );

    if (response.data.code === 200) {
      dispatch(
        fetchingPartnersDetailsSuccess(response.data.data, response.data.count)
      );
    } else {
      dispatch(fetchingPartnersDetailsFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchingPartnersDetailsFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const fetchState = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingState());
  try {
    let response = await api.get(`${API.fetchDealerState}?country=${payload}`);

    if (response.data.code === 200) {
      dispatch(fetchingStateSuccess(response.data.data));
    } else {
      dispatch(fetchingStateFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchingStateFailed(errorMessage));
    toast.error(errorMessage);
  }
};

//****** Fetching City  ********//

export const fetchCity = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingCity());
  try {
    let response = await api.get(
      `${API.fetchDealerCity}?country=${payload.countryCode}&stateName=${payload.state} `
    );

    if (response.data.code === 200) {
      dispatch(fetchingCitySuccess(response.data.data));
    } else {
      dispatch(fetchingCityFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchingCityFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const partnerForm = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(createPartner());
  try {
    let response = await api.post(`${API.partnerForm} `, payload);

    if (response.data.code === 200) {
      dispatch(createPartnerSuccess(response.data.data));
      callback && callback();
      toast.error(response.data.message);
    } else {
      dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const deletePartnerInfo = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(createPartner());
  try {
    let response = await api.delete(
      `${API.partnerForm}?partnerId=${payload.partnerId}&status=${payload.status}&rejectionReason=${payload.rejectionReason}&email=${payload.email}`
    );

    if (response.data.code === 200) {
      // dispatch(createPartnerSuccess(response.data.data));
      callback && callback();
      toast.error(response.data.message);
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const approveRejectPartner = (payload) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(createPartner());
  try {
    let response = await api.post(API.fetchPartnersList, payload);

    if (response.data.code === 200) {
      // dispatch(createPartnerSuccess(response.data.data));
      toast.error(response.data.message);
      history.push("/partner/list");
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const approveRejectUpdatedPartnerDetails = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(createPartner());
  try {
    let response = await api.put(API.updatePartner, payload);

    if (response.data.code === 200) {
      dispatch(fetchUpdatedPartnersData(payload.partnerId));
      // dispatch(createPartnerSuccess(response.data.data));
      toast.error(response.data.message);
      callback && callback();
      // history.push("/partner/list");
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const deleteUpdatedPartnerDetails = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(createPartner());
  try {
    let response = await api.delete(
      `${API.updatePartner}?partnerId=${payload.partnerId}&key=${payload.key}`
    );
    if (response.data.code === 200) {
      dispatch(fetchUpdatedPartnersData(payload.partnerId));
      // dispatch(createPartnerSuccess(response.data.data));
      toast.error(response.data.message);
      callback && callback();
      // history.push("/partner/list");
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const putPartnerForm = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(createPartner());
  try {
    let response = await api.put(`${API.partnerForm} `, payload);

    if (response.data.code === 200) {
      callback && callback();
      toast.error(response.data.message);
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const updatePartnerDetails = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(createPartner());
  try {
    let response = await api.post(`${API.updatePartner} `, payload);

    if (response.data.code === 200) {
      callback && callback();
      toast.error(response.data.message);
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const fetchingPieChartStatistics = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(pieChartStatistics());
  try {
    let response = await api.get(`${API.partnerAnalytics}`);

    if (response.data.code === 200) {
      dispatch(pieChartStatisticsSuccess(response.data.data));
    } else {
      dispatch(pieChartStatisticsFailed(response.data));
    }
  } catch (error) {
    dispatch(pieChartStatisticsFailed(errorMessage));
  }
};

export const partnerGalleryModeration = (payload, callback) => async (
  dispatch,
  getState,
  api
) => {
  // dispatch(createPartner());
  try {
    let response = await api.post(`${API.galleryModeration} `, payload);

    if (response.data.code === 200) {
      callback && callback();
      toast.error(response.data.message);
    } else {
      // dispatch(createPartnerFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    // dispatch(createPartnerFailed(errorMessage));
    toast.error(errorMessage);
  }
};

export const PartnerRanking = () => async (dispatch, getState, api) => {
  dispatch(partnerRanking());
  try {
    let response = await api.get(`${API.rankingApi} `);

    if (response.data.code === 200) {
      dispatch(partnerRankingSuccess(response.data.data));
    } else {
      dispatch(partnerRankingFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(partnerRankingFailed(errorMessage));
    toast.error(errorMessage);
  }
};
